import { API } from './constant';
import { HttpRequest } from '../../lib/http';
import { convert } from './convert';

export const updateData = ({ popupId, payload }: any) => {
  return HttpRequest({
    method: API.UPDATE.TYPE,
    url: API.UPDATE.URL(popupId),
    data: convert(payload),
  });
};
